import { useAppSelector } from '@/hooks/redux';
import { useGetContactSupportQuery } from '@/store/api/userApi';

/**
 * The best support channel the brand has configured, as an openable URL.
 *
 * WhatsApp first, Telegram second — the reference site's chat button is a live
 * conversation, and WhatsApp is what these operators actually staff. Returns
 * `null` when the brand has configured neither, so callers can drop the button
 * rather than render one that opens nothing.
 *
 * The query is shared with the footer through RTK Query's cache, so mounting
 * this in several places costs one request.
 */
export function useSupportLink(): string | null {
  useGetContactSupportQuery();
  const support = useAppSelector((state) => state.user.supportInfo);

  const whatsapp = support?.whatsapp?.trim();
  if (whatsapp) {
    // Operators enter these as anything from "+91 98765 43210" to a full wa.me
    // link; both have to end up as something the browser can open.
    if (/^https?:\/\//i.test(whatsapp)) return whatsapp;
    const digits = whatsapp.replace(/\D/g, '');
    if (digits) return `https://wa.me/${digits}`;
  }

  const telegram = support?.telegram?.trim();
  if (telegram) {
    if (/^https?:\/\//i.test(telegram)) return telegram;
    return `https://t.me/${telegram.replace(/^@/, '')}`;
  }

  return null;
}
